const handleSwitcherCondition = fn => (value) => {
  if (value === false) {
    return true;
  }
  return fn(value);
};

export default handleSwitcherCondition;
